module.exports = __webpack_public_path__ + "static/atrocity_murder_cases-7c438e2109331b4ff2377a7ba4c53116.png";